import { render, staticRenderFns } from "./BaseMoveGroup.vue?vue&type=template&id=3ff34285"
import script from "./BaseMoveGroup.vue?vue&type=script&lang=js"
export * from "./BaseMoveGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports